// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import store from './store';

import './plugins/axios';
import { router } from './plugins/vue-router';
import './plugins/vuex-router-sync';
import './plugins/bootstrap-vue';
import './plugins/stripe-checkout';
import './plugins/vue-meta';

Vue.config.productionTip = false;

function initVue() {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
  });
}

store.dispatch('auth/check')
  .then((response) => {
    store.commit('auth/LOGIN', response.data.data);
    initVue();
  })
  .catch(() => {
    initVue();
  });



// WEBPACK FOOTER //
// ./src/main.js